angular.module('impactx.controlstructure').controller('ControlStructureCtrl', [
    '$scope',
    'dataGen',
    '$routeParams',
    'BackService',
    'ToastService',
    'TranslationService',
    ControlStructureCtrl]);

function ControlStructureCtrl($scope, dataGen, $routeParams, BackService, ToastService, TranslationService) {
    $scope.id = $routeParams.id;
    $scope.endPointView = "";
    $scope.endPointSave = "";
    $scope.endPointDelete = "";

    $scope.getPageData = function () {
        return dataGen.getData($scope, {id: $scope.id}, $scope.endPointView);
    };

    $scope.savePageData = function () {
        var data = $scope.data;
        var dataObj = {
            data: data
        };

        return dataGen.post($scope, dataObj, $scope.endPointSave).then(function () {
            ToastService.openStandardToast($scope.trns.saveSuccess);
            BackService.back();
        })
    };

    $scope.delete = function () {
        return dataGen.postAsForm($scope, {controlId: $scope.id}, $scope.endPointDelete).then(function () {
            ToastService.openStandardToast(TranslationService.get("deleteSuccess"));
            BackService.back();
        })
    };
}